import { combineReducers } from "@reduxjs/toolkit";
import { addOnApi } from "slices/addOnApi";
import { authApi } from "slices/authApi";
import authSlice from "slices/authSlice";
import { blogApi } from "slices/blogApi";
import { catApi } from "slices/catApi";
import { chatApi } from "slices/chatApi";
import { locationApi } from "slices/locationApi";
import { planApi } from "slices/planApi";
import { productsApi } from "slices/productsApi";
import { quizApi } from "slices/quizApi";
import { usersApi } from "slices/usersApi";
import { categorySlice } from "slices/beautyApp/categorySlice";
import { subCategorySlice } from "slices/beautyApp/subCatSlice";
import { serviceType } from "slices/beautyApp/serviceType";
import { packageSlice } from "slices/beautyApp/packageSlice";
import { productSlice } from "slices/beautyApp/productSlice";
import { beauticianSlice } from "slices/beautyApp/beauticianSlice";
import { shopCatSlice } from "slices/eCommerce/shopCatSlice";
import { shopSubCat } from "slices/eCommerce/shopSubCat";
import { brandSlice } from "slices/eCommerce/brandSlice";
import { colorSlice } from "slices/eCommerce/colorSlice";
import { sizeSlice } from "slices/eCommerce/sizeSlice";
import { shopProducts } from "slices/eCommerce/shopProducts";
import { locationSlice } from "slices/common/locationSlice";
import { timeslotSlice } from "slices/common/timeslotSlice";
import { orderSlice } from "slices/common/orderSlice";
import { offerSlice } from "slices/common/offerSlice";
import { concernSlice } from "slices/wellness/concernSlice";
import { doctorSlice } from "slices/wellness/doctorSlice";
import { clinicSlice } from "slices/wellness/clinicSlice";
import { staffSlice } from "slices/staffSlice";
import { scanSlice } from "slices/skin/scanSlice";
import { jobApply } from "slices/beautyApp/jobApply";
import { testimonialSlice } from "slices/cms/testimonialSlice";
import { homeSlice } from "slices/cms/homeSlice";
import { blogSlice } from "slices/cms/blogSlice";
import { servicePackageSlice } from "slices/beautyApp/servicePackageSlice";
import { dashboardSlice } from "slices/common/dashboardSlice";
import { alertSlice } from "slices/common/alertSlice";
import { couponSlice } from "slices/common/couponSlice";
import { addOnStockSlice } from "slices/beautyApp/addOnStockSlice";
import { subscriptionSlice } from "slices/beautyApp/subscriptionSlice";
import { reportIssueSlice } from "slices/common/reportIssueSlice";

const rootReducer = combineReducers({
  auth: authSlice,
  [authApi.reducerPath]: authApi.reducer,
  [usersApi.reducerPath]: usersApi.reducer,
  [productsApi.reducerPath]: productsApi.reducer,
  [chatApi.reducerPath]: chatApi.reducer,
  [catApi.reducerPath]: catApi.reducer,
  [locationApi.reducerPath]: locationApi.reducer,
  [planApi.reducerPath]: planApi.reducer,
  [addOnApi.reducerPath]: addOnApi.reducer,
  [blogApi.reducerPath]: blogApi.reducer,
  [quizApi.reducerPath]: quizApi.reducer,

  // madam G
  [categorySlice.reducerPath]: categorySlice.reducer,
  [subCategorySlice.reducerPath]: subCategorySlice.reducer,
  [serviceType.reducerPath]: serviceType.reducer,
  [packageSlice.reducerPath]: packageSlice.reducer,
  [productSlice.reducerPath]: productSlice.reducer,
  [beauticianSlice.reducerPath]: beauticianSlice.reducer,
  [jobApply.reducerPath]: jobApply.reducer,
  [homeSlice.reducerPath]: homeSlice.reducer,
  [servicePackageSlice.reducerPath]: servicePackageSlice.reducer,
  [addOnStockSlice.reducerPath]: addOnStockSlice.reducer,
  [subscriptionSlice.reducerPath]: subscriptionSlice.reducer,

  // e commerce
  [shopCatSlice.reducerPath]: shopCatSlice.reducer,
  [shopSubCat.reducerPath]: shopSubCat.reducer,
  [brandSlice.reducerPath]: brandSlice.reducer,
  [colorSlice.reducerPath]: colorSlice.reducer,
  [sizeSlice.reducerPath]: sizeSlice.reducer,
  [shopProducts.reducerPath]: shopProducts.reducer,

  // commom
  [locationSlice.reducerPath]: locationSlice.reducer,
  [timeslotSlice.reducerPath]: timeslotSlice.reducer,
  [orderSlice.reducerPath]: orderSlice.reducer,
  [offerSlice.reducerPath]: offerSlice.reducer,
  [testimonialSlice.reducerPath]: testimonialSlice.reducer,
  [blogSlice.reducerPath]: blogSlice.reducer,
  [dashboardSlice.reducerPath]: dashboardSlice.reducer,
  [alertSlice.reducerPath]: alertSlice.reducer,
  [couponSlice.reducerPath]: couponSlice.reducer,
  [reportIssueSlice.reducerPath]: reportIssueSlice.reducer,

  // wellness
  [concernSlice.reducerPath]: concernSlice.reducer,
  [doctorSlice.reducerPath]: doctorSlice.reducer,
  [clinicSlice.reducerPath]: clinicSlice.reducer,
  [staffSlice.reducerPath]: staffSlice.reducer,

  // skinn
  [scanSlice.reducerPath]: scanSlice.reducer,
});

export default rootReducer;
